import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, ColumnElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type ColumnProps = RecursivePartial<ColumnElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | ColumnElement["children"];
  data?: ColumnElement["data"];
};

export function Column(props: ColumnProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: ColumnElement = {
    type: BasicType.COLUMN,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
